<app-page>
    <app-title>{{ email }}</app-title>
    <app-orders [ordersModel]="ordersModel"></app-orders>
</app-page>
